/* eslint-disable local-rules/require-storybook-documentation */
import { FC } from 'react';
import { Spinner, Text, Box } from '@zillow/constellation-10';

/**
 * Renders a spinner experience while the authentication decision is pending.
 * @stories {@link file://./../stories/Molecular/PageSpinnerExperience.stories.tsx}
 */
export const PageSpinnerExperience: FC<{ message?: string }> = ({ message }) => (
    <Box
        css={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            gap: 'md',
            boxSizing: 'border-box',
            padding: 'md',
        }}>
        {message && (
            <Text css={{ textAlign: 'center', textStyle: { base: 'heading-xl', mdDown: 'heading-md' } }}>
                {message}
            </Text>
        )}

        <Spinner size="xl" />
    </Box>
);
